// extracted by mini-css-extract-plugin
export var box = "_5g-0";
export var check = "_5g-1";
export var checkboxButton = "_5g-6";
export var checkboxGroup = "_5g-5";
export var disabled = "_5g-7";
export var ghost = "_5g-9";
export var input = "_5g-2";
export var label = "_5g-4";
export var normal = "_5g-8";
export var uncheck = "_5g-3";